export default __webpack_public_path__ + "static/media/arrowUp.f34ef3f4.svg";